<template>
  <router-link
    :to="{ name: item.name }"
    class="flex items-center p-2 rounded cursor-pointer transition-colors duration-200"
    :class="{
      'text-white bg-gray-800': isActive,
      'text-gray-400 hover:text-gray-700 hover:bg-gray-100': !isActive
    }"
  >
    <i :class="item.icon" class="mr-2"></i>
    <span>{{ item.name }}</span>
  </router-link>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.$route.name === this.item.name;
    },
  },
};
</script>
